<div class="row mt-1 text-center w-100" *ngIf="item.recomendations">
  <ng-container *ngFor="let recomendation of item.recomendations">
    <ng-container *ngIf="recomendation.key === TYPE_PRODUCT.hot && recomendation.value">
      <div class="col">
        <p class="{{menu.fontText}} m-0" [ngStyle]="{'color': menu.colorText}">
          <i class="fas fa-pepper-hot  mr-1"></i>{{language === 'ES'? 'Picante': 'Hot'}}
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf="recomendation.key === TYPE_PRODUCT.vegan && recomendation.value">
      <div class="col">
        <p class="{{menu.fontText}} m-0" [ngStyle]="{'color': menu.colorText}">
          <i class="fas fa-seedling mr-1"></i>{{language === 'ES'? 'Vegano': 'Vegan'}}
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf="recomendation.key === TYPE_PRODUCT.vegetarian && recomendation.value">
      <div class="col">
        <p class="{{menu.fontText}} m-0" [ngStyle]="{'color': menu.colorText}">
          <i class="fas fa-seedling mr-1"></i>{{language === 'ES'? 'Vegetariano': 'Vegetarian'}}
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf="recomendation.key === TYPE_PRODUCT.gluten && recomendation.value">
      <div class="col">
        <p class="{{menu.fontText}} m-0" [ngStyle]="{'color': menu.colorText}">
          <i class="fas fa-wheat-awn mr-1"></i>{{language === 'ES'? 'Sin gluten': 'Gluten free'}}
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf="recomendation.key === TYPE_PRODUCT.late && recomendation.value">
      <div class="col">
        <p class="{{menu.fontText}} m-0" [ngStyle]="{'color': menu.colorText}">
          <i class="fas fa-clock-rotate-left mr-1"></i>{{language === 'ES'? 'Tardío': 'Late'}}
        </p>
      </div>
    </ng-container>
  </ng-container>

</div>